import PropTypes from 'prop-types';
export default {
  types: {
    /**
     * Whether the English or French copy will be used (e.g. for accessibility labels).
     */
    copy: PropTypes.oneOf(['en', 'fr']),
    /**
     * The input label.
     */
    label: PropTypes.string,
    /**
     * A short description of the expected input.
     */
    hint: PropTypes.string,
    /**
     * Position of the hint relative to label. Use `below` to display a larger hint below the label.
     */
    hintPosition: PropTypes.oneOf(['inline', 'below']),
    /**
     * A detailed description of validation error/success or additional instructions.
     * Visual variant is determined based on the `validation` prop.
     */
    feedback: PropTypes.string,
    /**
     * Tokens to be passed to the feedback component.
     */
    feedbackTokens: PropTypes.object,
    /**
     * Props to be passed to the feedback component.
     */
    feedbackProps: PropTypes.object,
    /**
     * Content of an optional `Tooltip`. If set, a tooltip button will be shown next to the label.
     */
    tooltip: PropTypes.string,
    /**
     * Use to visually mark an input as valid or invalid.
     */
    validation: PropTypes.oneOf(['error', 'success']),
    /**
     * The text value from an input field.
     */
    inputValue: PropTypes.string,
    /**
     * Max number of characters allowed id an input text.
     */
    maxCharacterAllowed: PropTypes.number
  },
  select: _ref => {
    let {
      copy,
      label,
      hint,
      hintPosition,
      feedback,
      feedbackTokens,
      feedbackProps,
      tooltip,
      validation,
      inputValue,
      maxCharacterAllowed
    } = _ref;
    return {
      supportsProps: {
        copy,
        label,
        hint,
        hintPosition,
        feedback,
        feedbackTokens,
        feedbackProps,
        tooltip,
        validation,
        inputValue,
        maxCharacterAllowed
      }
    };
  }
};